var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jd-button-box"},[_c('el-button',{class:[
      'jd-btn',
      _vm.typeClass,
      _vm.hasMinWidth,
      _vm.hasLightHight,
      _vm.textDisabled,
      _vm.disabledClass,
    ],style:(_vm.btnWidth != '' ? { width: _vm.btnWidth } : _vm.styleObj),attrs:{"v-zoom":_vm.isZoom ? { from: _vm.zFormText, name: _vm.zNameText } : {},"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }